import React, { useState } from "react";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { InlineMath } from "react-katex";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Marimencoba from "./marimencoba/Marimencoba";
import MediaQuery from "react-responsive";
import { Scrollbar } from "react-scrollbars-custom";
const useStyles = makeStyles((theme) => ({
	appBar: {
		position: "relative",
		backgroundColor: "#40bf80",
	},
	title: {
		margin: "auto",
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});
const Ch3 = ({ukuranH,ukuranP}) => {
	const classes = useStyles();
	const [jawaban3, setJawaban3] = useState(false);
	const clickSetJawaban3 = () => setJawaban3(!jawaban3);
	const [openmencobadialog, setOpenmencobadialog] = useState(false);
	const openMencobaDialog = () => {
		setOpenmencobadialog(true);
	};
	const closemencobaDialog = () => {
		setOpenmencobadialog(false);
	};
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [form1, setForm1] = useState({ width: "50px", height: "30px" });
	const [form2, setForm2] = useState({ width: "50px", height: "30px" });
	const [form3, setForm3] = useState({ width: "50px", height: "30px" });
	const [form4, setForm4] = useState({ width: "50px", height: "30px" });
	const [form5, setForm5] = useState({ width: "50px", height: "30px" });
	const [form6, setForm6] = useState({ width: "50px", height: "30px" });
	const [form7, setForm7] = useState({ width: "50px", height: "30px" });
	const [form8, setForm8] = useState({ width: "50px", height: "30px" });

	//barurevisi
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);
	const [show8, setShow8] = useState(false);
	const [show9, setShow9] = useState(false);
	const [show10, setShow10] = useState(false);
	const [show11, setShow11] = useState(false);
	const [show12, setShow12] = useState(false);
	const [show13, setShow13] = useState(false);
	const [show14, setShow14] = useState(false);
	const [show15, setShow15] = useState(false);
	const [show16, setShow16] = useState(false);
	const [form9, setForm9] = useState({ width: "50px", height: "30px" });
	const [form10, setForm10] = useState({ width: "50px", height: "30px" });
	const [form11, setForm11] = useState({ width: "50px", height: "30px" });
	const [form12, setForm12] = useState({ width: "50px", height: "30px" });
	const [form13, setForm13] = useState({ width: "50px", height: "30px" });
	const [form14, setForm14] = useState({ width: "50px", height: "30px" });
	const [form15, setForm15] = useState({ width: "50px", height: "30px" });
	const [form16, setForm16] = useState({ width: "50px", height: "30px" });
	const handleform1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "30") {
			setShow6(true);
			setForm1({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm1({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm1({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "20") {
			setShow7(true);
			setForm2({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm2({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm2({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "75") {
			setShow8(true);
			setForm3({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm3({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm3({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "18") {
			setShow1(true);
			setForm4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "24") {
			setShow2(true);
			setForm5({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm5({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm5({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "72") {
			setShow3(true);
			setForm6({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm6({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm6({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow4(true);
			setForm7({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm7({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm7({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow5(true);
			setForm8({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm8({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm8({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};

	//barurevisi
	const handleform9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "X") {
			setShow9(true);
			setForm9({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm9({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm9({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "Y") {
			setShow10(true);
			setForm10({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm10({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm10({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "6") {
			setShow11(true);
			setForm11({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm11({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm11({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setShow12(true);
			setForm12({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm12({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm12({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform13 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "15") {
			setShow13(true);
			setForm13({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm13({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm13({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform14 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setShow14(true);
			setForm14({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm14({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm14({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform15 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setShow15(true);
			setForm15({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm15({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm15({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform16 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "12") {
			setShow16(true);
			setForm16({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm16({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm16({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	return (
		<div
			style={{
				margin: "auto",
				lineHeight: "35px",
				textAlign: "justify",
				width: "100%",
				borderStyle: "solid",
				borderColor: "#2d8659",
				borderRadius: "25px",
				boxShadow: "5px 5px #888887",
			}}
			className="mt-2 mb-2"
		>
			<div
				style={{
					width: "80%",
					margin: "auto",
				}}
			>
				<p
					style={{
						textIndent: "2rem",
						width: "100%",
						textAlign: "justify",
						lineHeight: "35px",
						fontSize :`${ukuranP}px`
					}}
				>
					Produk A membutuhkan 30 kg bahan mentah dan 18 jam waktu kerja mesin.
					Produk B membutuhkan 20 kg bahan mentah dan 24 jam waktu kerja mesin.
					Bahan mentah yang tersedia 75 kg dan waktu kerja mesin 72 jam. Buatlah
					model matematikanya !
				</p>
			</div>
			<div
				style={{
					marginLeft: "1rem",
					color: "green",
					display: "flex",
					justifyContent: "space-between",
					width: "10%",
				}}
			>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.3s alternate ease infinite",
					}}
				>
					<SkipNextIcon />
				</div>
				<p
					style={{ marginLeft: "22px", cursor: "pointer" }}
					onClick={clickSetJawaban3}
				>
					<strong>
						<u>Jawaban</u>
					</strong>
				</p>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.2s alternate ease infinite",
					}}
				>
					<SkipPreviousIcon />
				</div>
			</div>
			{jawaban3 ? (
				<div
					style={{
						margin: "auto",
						width: "80%",
						position: "relative",
						textAlign: "justify",
					}}
				>
					<ol style={{fontSize:`${ukuranP}px`}}>
						<li>Pertama kita buat tabel, agar memudahkan kita dalam menyusun model matematikanya! </li>
						<MediaQuery minWidth={476} maxWidth={1824}>
							<div>
								<table
									className="table"
									style={{
										border: "2px solid green",
										borderCollapse: "collapse",

										textAlign: "center",
									}}
								>
									<tr>
										<th
											style={{
												border: "2px solid green",
											}}
										>
											Pembatas
										</th>
										<th
											style={{
												border: "2px solid green",
											}}
										>
											Produk A
										</th>
										<th
											style={{
												border: "2px solid green",
											}}
										>
											Produk B
										</th>
										<th
											style={{
												border: "2px solid green",
											}}
										>
											Persediaan
										</th>
										<th
											style={{
												border: "2px solid green",
											}}
										>
											Satuan
										</th>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Bahan Mentah
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" onChange={handleform1} style={form1} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" onChange={handleform2} style={form2} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" onChange={handleform3} style={form3} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Kg
										</td>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Waktu Kerja
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" onChange={handleform4} style={form4} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" onChange={handleform5} style={form5} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" onChange={handleform6} style={form6} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Jam
										</td>
									</tr>
								</table>
							</div>
						</MediaQuery>
						<MediaQuery maxWidth={475}>
							<Scrollbar style={{ width: "80%", height: 300 }}>
								<div>
									<table
										className="table"
										style={{
											border: "2px solid green",
											borderCollapse: "collapse",

											textAlign: "center",
										}}
									>
										<tr>
											<th
												style={{
													border: "2px solid green",
												}}
											>
												Pembatas
											</th>
											<th
												style={{
													border: "2px solid green",
												}}
											>
												Produk A
											</th>
											<th
												style={{
													border: "2px solid green",
												}}
											>
												Produk B
											</th>
											<th
												style={{
													border: "2px solid green",
												}}
											>
												Persediaan
											</th>
											<th
												style={{
													border: "2px solid green",
												}}
											>
												Satuan
											</th>
										</tr>

										<tr>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Bahan Mentah
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													onChange={handleform1}
													style={form1}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													onChange={handleform2}
													style={form2}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													onChange={handleform3}
													style={form3}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Kg
											</td>
										</tr>

										<tr>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Waktu Kerja
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													onChange={handleform4}
													style={form4}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													onChange={handleform5}
													style={form5}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													onChange={handleform6}
													style={form6}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Jam
											</td>
										</tr>
									</table>
								</div>
							</Scrollbar>
						</MediaQuery>
						{show1 && show2 && show3 && show6 && show7 && show8 ? (
							<div>
								<li>
									<p>Dengan memisalkan :</p>
									<p className="text-center alert alert-warning h6">
										Kalian harus menyesuaikan seperti contoh soal sebelumnya
									</p>
									<ul>
										<li>
										<input type="text" onChange={handleform9} style={form9} /> = banyaknya pupuk A
										</li>
										<li>
										<input type="text" onChange={handleform10} style={form10} /> = banyaknya pupuk B
										</li>
									</ul>
								</li>
						{show9&&show10?
						<>
								<li>
									<p>Maka Penggunaan bahan mentah :{" "}</p>
									<p>
									<InlineMath math="\iff" />
										<i>
										<b>30x + 20y ≤ 75 </b>
										</i>
									</p>
									<p><InlineMath math="\iff"/> Disederhanakan menjadi :</p>
									<p>
									<InlineMath math="\iff" />
										<i>
											<b><input type="text" onChange={handleform11} style={form11} />x + <input type="text" onChange={handleform12} style={form12} />y ≤ <input type="text" onChange={handleform13} style={form13} /></b>
										</i>
									</p>
							</li>
						{show11&&show12&&show13?
						<>
									<p>
										Penggunaan waktu kerja :									
									</p>
									<p>
									<InlineMath math="\iff" />
									<i>
									<b>18x + 24y ≤ 72 </b>
									</i>
									</p>
									<p><InlineMath math="\iff"/> Disederhanakan menjadi :</p>
									<p>
									<InlineMath math="\iff" />
										<i>
											<b><input type="text" onChange={handleform14} style={form14} />x + <input type="text" onChange={handleform15} style={form15} />y ≤ <input type="text" onChange={handleform16} style={form16} /></b>
										</i>
									</p>
				{show14&&show15&&show16?
				<>
	<li>
									Karena tidak mungkin ketersediaan produk negatif, sehingga
									dapat dituliskan{" "}
									<b>
										<i>
											x ≥{" "}
											<input type="text" style={form7} onChange={handleform7} />
										</i>
									</b>{" "}
									dan{" "}
									<b>
										<i>
											y ≥{" "}
											<input type="text" style={form8} onChange={handleform8} />
										</i>
									</b>{" "}
								</li>
								{show4 && show5 ? (
									<div>
										<li>Maka model matematikanya adalah</li>
										<div className="text-center mt-1">
											<InlineMath math=" 6x + 4y ≤ 15 ; " />
											<InlineMath math=" 3x + 4y ≤ 12;  " />
											<InlineMath math=" x ≥ 0 ; y ≥ 0" />
										</div>

										<div className="d-flex justify-content-center">
											<button
												className="btn btn-outline-success mt-2 mb-2"
												onClick={openMencobaDialog}
											>
												Mari Mencoba
											</button>
										</div>
									</div>
								) : null}
				</>
				:null}				
							
						</>
						:null}
						</>
						:null}
							</div>
						) : null}
					</ol>
				</div>
			) : null}
			<div>
				<Dialog
					fullScreen
					open={openmencobadialog}
					onClose={closemencobaDialog}
					TransitionComponent={Transition}
				>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								edge="start"
								color="inherit"
								onClick={closemencobaDialog}
								aria-label="close"
							>
								<CloseIcon />
							</IconButton>
							<h4 className={classes.title}>Mari Mencoba Program Linear</h4>
						</Toolbar>
					</AppBar>

					<Marimencoba />
				</Dialog>
			</div>
		</div>
	);
};

export default Ch3;
